import React from 'react';
import PropTypes from 'prop-types';

const TrackDifficultyIcon = ({ color, width, height }) => (
   <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      version="1.1"
      style={{ width, height }}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
   >
      <path
         fill={color}
         strokeWidth="1"
         d="M6.9941,10.6993 L12.1511,11.7183 L9.3411,13.5993 L12.1651,14.1573 L16.1481,11.4883 L13.4791,7.5053 L10.6551,6.9473 L12.5391,9.7563 L8.1171,8.8833 L12.3701,2.0003 C12.3701,2.0003 12.3731,2.0003 12.3771,2.0003 L17.0831,9.5193 L18.7921,12.2483 L20.4811,9.5073 L21.2241,8.3003 L26.3301,16.2143 L3.5871,16.2143 L6.9941,10.6993 Z M22.9061,7.2163 C22.5121,6.6043 21.8681,6.3003 21.2251,6.3003 C20.5681,6.3003 19.9121,6.6173 19.5221,7.2503 L18.7781,8.4573 L14.0721,0.9393 C13.6801,0.3123 13.0281,0.0003 12.3771,0.0003 C11.7221,0.0003 11.0661,0.3163 10.6761,0.9483 L0.0001,18.2143 L30.0001,18.2143 L22.9061,7.2163 Z"/>
   </svg>
);

TrackDifficultyIcon.propTypes = {
   color: PropTypes.string
};

TrackDifficultyIcon.defaultProps = {
   width: 30,
   height: 19
};

export default TrackDifficultyIcon;
